var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMartini(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m54.541 14.274c.287-.346.459-.79.459-1.274 0-1.104-.896-2-2-2h-7.865l2.807-3.006c.019 0 .037.006.058.006 1.656 0 3-1.343 3-3s-1.344-3-3-3-3 1.343-3 3c0 .088.019.17.025.256l-5.361 5.744h-32.664c-1.104 0-2 .896-2 2 0 .484.172.928.459 1.274l22.541 28.422v11.304h-7c-1.104 0-2 .896-2 2s.896 2 2 2h18c1.104 0 2-.896 2-2s-.896-2-2-2h-7v-11.304zm-43.29.726h24.681l-4.666 5h5.47l4.667-5h7.347l-4.138 5h-7.876-21.347z",
    fill: "rgb(0,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMartini);
export default __webpack_public_path__ + "static/media/martini.240ff934fc88c3adadc414ed41cd3757.svg";
export { ForwardRef as ReactComponent };